import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { firstValueFrom } from 'rxjs';
import { RawStock } from '../../interface/raw-stock';

@Injectable({
  providedIn: 'root'
})
export class RawStockService {
  constructor(private http: HttpService) {}

  getAll(): Promise<RawStock[]> {
    return firstValueFrom(this.http.get('/RawStocks'));
  }

  getLowStock(): Promise<RawStock[]> {
    return firstValueFrom(this.http.get('/RawStocks/LowStock'));
  }

  adjustStock(materialId: number, quantity: number, price?: number): Promise<any> {
    return firstValueFrom(this.http.post(`/RawStocks/${materialId}/adjust`, { quantity, price }));
  }

  nullifyStock(materialId: number): Promise<any> {
    return firstValueFrom(this.http.post(`/RawStocks/${materialId}/nullify`, {}));
  }
}
